import { Avatar, Card, Grid, ListItem, Stack, Typography } from "@mui/material";

const DescripcionCard = ({nombre, descripcion, razonSocial, imagen, contratoEn}) => {
  return <ListItem sx={{paddingInlineStart: 0}}>
    <Grid container spacing={1} >
      <Grid item sm={2}><Avatar src={ imagen } /></Grid>
      <Grid item container sm={10}>
        <Grid item sm={12}><Typography >{descripcion}</Typography></Grid>
        {!!razonSocial && <Grid item sm={12}><Typography color="rgb(150,50,50)">{razonSocial}</Typography></Grid>}
        <Grid item sm={12}><Typography color="blue">{'Contrato en: ' + contratoEn}</Typography></Grid>
      </Grid>
    </Grid>
  </ListItem>
}

export default DescripcionCard;